import { z } from 'zod';
import { dateRangeSchema } from 'utils/schemas';
import {
  integrationLogItemLevels,
  integrationLogStatuses,
} from './integrations.types';

export const integrationLogItemsFiltersSchema = z.object({
  level: z.array(z.enum(integrationLogItemLevels)).catch([]),
});

export const integrationLogsFiltersSchema = z.object({
  status: z.array(z.enum(integrationLogStatuses)).catch([]),
});

export const apiIntegrationLogsFiltersSchema = z.object({
  level: z.enum(integrationLogItemLevels).nullable().catch(null),
  search: z.string().catch(''),
  date: dateRangeSchema,
  limit: z.coerce.number().finite().int().min(1).catch(100),
});
